// extracted by mini-css-extract-plugin
export default {"root":"icon-module--root--ozzqi","customColor":"icon-module--customColor--fwjU7"};